import type { Mood } from "./look";

/** An agent's little character. Eyes, mouth and posture follow its mood; colour, shape and accessory say which agent it is. */
export function Buddy({ color, shape, size = 64, mood = "idle", acc = "none" }: { color: string; shape: string; size?: number; mood?: Mood; acc?: "none" | "antenna" | "ring" | "sprout" }) {
  const openEyes = mood === "idle" || mood === "work" || mood === "wait" || mood === "happy";
  const pupil = mood === "work" ? "translate(2px,3px)" : mood === "wait" ? "translate(0px,-3px)" : "translate(0px,0px)";
  const blush = acc === "sprout" || mood === "done";
  return (
    <span className="tw-buddy" style={{ width: size, height: size }} data-mood={mood} aria-hidden>
      <span className="tw-buddy-art" style={{ transform: `scale(${size / 64})` }}>
        {acc === "antenna" && (
          <>
            <span className="tw-b" style={{ left: 31, top: -12, width: 2, height: 13, background: color }} />
            <span className="tw-b tw-pulse" style={{ left: 27, top: -18, width: 10, height: 10, borderRadius: "50%", background: color, boxShadow: `0 0 10px ${color}` }} />
          </>
        )}
        {acc === "sprout" && (
          <>
            <span className="tw-b" style={{ left: 20, top: -8, width: 13, height: 9, borderRadius: "12px 0", background: "oklch(0.78 0.16 145)", transform: "rotate(-24deg)" }} />
            <span className="tw-b" style={{ left: 31, top: -10, width: 13, height: 9, borderRadius: "0 12px", background: "oklch(0.7 0.16 145)", transform: "rotate(18deg)" }} />
          </>
        )}
        <span className="tw-b" style={{ inset: 0, background: color, borderRadius: shape, boxShadow: "inset -5px -7px 0 rgba(0,0,0,.14), inset 4px 5px 0 rgba(255,255,255,.2)" }} />
        {blush && (
          <>
            <span className="tw-b" style={{ left: 6, top: 38, width: 11, height: 6, borderRadius: "50%", background: "rgba(255,110,110,.45)" }} />
            <span className="tw-b" style={{ left: 47, top: 38, width: 11, height: 6, borderRadius: "50%", background: "rgba(255,110,110,.45)" }} />
          </>
        )}
        {openEyes &&
          [13, 36].map((left) => (
            <span key={left} className="tw-b tw-eye" style={{ left, top: 19, width: 15, height: 17, borderRadius: "50%", background: "#fff", overflow: "hidden" }}>
              <span className="tw-b" style={{ left: 4, top: 5, width: 8, height: 8, borderRadius: "50%", background: "#141716", transform: pupil, transition: "transform .4s" }} />
            </span>
          ))}
        {mood === "done" &&
          [13, 37].map((left) => <span key={left} className="tw-b" style={{ left, top: 24, width: 10, height: 6, border: "3px solid #141716", borderBottom: "none", borderRadius: "12px 12px 0 0" }} />)}
        {mood === "fail" && (
          <>
            <span className="tw-b" style={{ left: 14, top: 27, width: 13, height: 3, borderRadius: 2, background: "#141716", transform: "rotate(14deg)" }} />
            <span className="tw-b" style={{ left: 37, top: 27, width: 13, height: 3, borderRadius: 2, background: "#141716", transform: "rotate(-14deg)" }} />
            <span className="tw-b" style={{ left: 52, top: 8, width: 7, height: 10, borderRadius: "50% 50% 50% 50% / 65% 65% 35% 35%", background: "oklch(0.86 0.08 230)" }} />
          </>
        )}
        {(mood === "idle" || mood === "happy" || mood === "done") && <span className="tw-b" style={{ left: 23, top: 40, width: 12, height: 7, border: "3px solid #141716", borderTop: "none", borderRadius: "0 0 12px 12px" }} />}
        {mood === "fail" && <span className="tw-b" style={{ left: 24, top: 44, width: 10, height: 6, border: "3px solid #141716", borderBottom: "none", borderRadius: "10px 10px 0 0" }} />}
        {mood === "wait" && <span className="tw-b" style={{ left: 27, top: 41, width: 6, height: 7, border: "2.5px solid #141716", borderRadius: "50%" }} />}
        {mood === "work" && <span className="tw-b" style={{ left: 26, top: 44, width: 12, height: 3, borderRadius: 2, background: "#141716" }} />}
        {acc === "ring" && <span className="tw-b" style={{ left: -9, top: 47, width: 78, height: 14, borderRadius: "50%", border: "2.5px solid oklch(0.86 0.09 305)", borderTopColor: "transparent", transform: "rotate(-12deg)" }} />}
      </span>
    </span>
  );
}
